import { Subscription } from 'rxjs';

export class LoadingConfig implements LoadingConfigInterface {
  delay?: number;
  minDuration?: number;
  backdrop?: boolean;
  message?: string;
  wrapperClass?: string;
  onActivateTick?:boolean;
  constructor(config: LoadingConfigInterface = {}) {
    for (let option in BUSY_CONFIG_DEFAULTS) {
      this[option] =
        config[option] != null ? config[option] : BUSY_CONFIG_DEFAULTS[option];
    }
  }
}

export interface LoadingConfigInterface {
  delay?: number;
  minDuration?: number;
  backdrop?: boolean;
  message?: string;
  wrapperClass?: string;
  onActivateTick?:boolean
  busy?: Promise<any> | Subscription | Array<Promise<any> | Subscription>;
}

export const BUSY_CONFIG_DEFAULTS = {
  delay: 0,
  minDuration: 0,
  backdrop: true,
  message: 'Please wait...',
  wrapperClass: 'ng-busy',
  onActivateTick:false,
};
